/**
 * Read the airclou_csrf cookie value for CSRF double-submit pattern.
 * The cookie is set by the Auth service with httpOnly: false and
 * domain: .airclou.com, so it's readable from all Airclou subdomains.
 */
export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)airclou_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

